var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper"},[(_vm.loaded)?_c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":40,"width":40},on:{"animCreated":_vm.handleAnimation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }